module.exports = __webpack_public_path__ + "static/media/left_filled.c0f4d412.svg";